<script>
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';
import { ATTACHMENT_ICONS } from 'shared/constants/messages';
import {
  DRAFT_ATTACHMENT_LABELS,
  DRAFT_PREFIX_LABEL,
  draftAttachmentKind,
} from 'dashboard/helper/draftMessageHelper';

// Aceleres: linha "Rascunho: ..." da lista de conversas, no formato do
// WhatsApp. Fica ao lado do MessagePreview e ocupa o mesmo lugar dele quando a
// conversa tem algo escrito ou anexado que ainda não foi enviado.
export default {
  name: 'DraftPreview',
  props: {
    draft: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { getPlainText } = useMessageFormatter();
    return { getPlainText };
  },
  computed: {
    prefixLabel() {
      return DRAFT_PREFIX_LABEL;
    },
    firstAttachment() {
      return this.draft.attachments?.[0] || null;
    },
    attachmentKind() {
      return this.firstAttachment
        ? draftAttachmentKind(this.firstAttachment)
        : '';
    },
    attachmentIcon() {
      return ATTACHMENT_ICONS[this.attachmentKind];
    },
    // Ao anexar o primeiro arquivo o compositor move o texto do editor para a
    // legenda do anexo. Por isso a legenda vem antes do rótulo do tipo: é o
    // que a pessoa escreveu.
    draftContent() {
      if (this.firstAttachment) {
        const caption = this.firstAttachment.caption?.trim();
        return caption || DRAFT_ATTACHMENT_LABELS[this.attachmentKind];
      }

      return this.getPlainText(this.draft.text || '').trim();
    },
  },
};
</script>

<template>
  <div class="overflow-hidden text-ellipsis whitespace-nowrap">
    <span class="font-medium text-n-slate-12">{{ prefixLabel }}</span>
    <fluent-icon
      v-if="attachmentIcon"
      size="16"
      class="-mt-0.5 mx-0.5 align-middle inline-block text-n-slate-11"
      :icon="attachmentIcon"
    />
    <span class="mx-0.5">{{ draftContent }}</span>
  </div>
</template>
